Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-product-compare-list'),
        wrapper;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);

    var model = null;

    wrapper.loading = function loading (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.extendModel = function () {
        model = { ...model, ...{ ClientEnhancedModel: window.LhApp.ClientEnhancedModel } }; // model to be expanded from page html (window.LhApp = window.LhApp || {}; window.LhApp.ClientEnhancedModel = window.LhApp.ClientEnhancedModel || {};
    };

    wrapper.calcHeight = function () {
        var $boxes = $('.x-product-compare-box', $wrapper);
        var maxHeight = 0;

        $boxes.each(function (index) {
            var $box = $(this);
            var height = $('.control-area-one', $box).height();

            if (height > maxHeight) {
                maxHeight = height;
            } else {
                $('.control-area-one', $box).height(maxHeight);
            }              
        });
    };

    wrapper.update = function () {
        wrapper.loading(true);

        var html = Vendd.Handlebars.parse(Handlebars.partials.productCompareList_A, model);

        wrapper.bind(html);

        wrapper.calcHeight();

        wrapper.loading(false);
        $(window).resize($.debounce(100, function () {
            wrapper.calculateWidth();
        }));
    };

    wrapper.bind = function bind(html) {
        $wrapper.html(html);

        Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($wrapper));

        if ($('.product-compare-list', $wrapper) .length > 0 && $('.product-compare-list', $wrapper).width() < $('.product-compare-list', $wrapper).get(0).scrollWidth) {
            $('.product-features', $wrapper).addClass('has-scrollbar');
        }

        if (model.Products.length > 0 && model.Products[0].WishlistEnabled) {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Wishlist.Messages.GetModel());
        }
    };
    wrapper.calculateWidth = function () {
        var ww = $(window).width();

        if (ww < 768) return;
        var windowWidth = $('.compare-table', $wrapper).outerWidth();
        var productsWidth = 0;
        var $products = $('.product-compare-list .x-product-compare-box', $wrapper);

        $products.each(function (index, product) {
            productsWidth += $(product).outerWidth();
        });

        productsWidth = productsWidth + $('.product-features', $wrapper).outerWidth();

        if (productsWidth >= windowWidth) {
            $('.product-features', $wrapper).addClass('has-scrollbar');
            $('.product-compare-list', $wrapper).addClass('has-scrollbar');
        } else {
            $('.product-features', $wrapper).removeClass('has-scrollbar');
            $('.product-compare-list', $wrapper).removeClass('has-scrollbar');
        }

    }
    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.Changed, wrapper, function (envelope) {
        wrapper.loading(true);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetModel());
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetModelSuccess, wrapper, function (envelope) {
        model = envelope.message.data.model;

        wrapper.loading(true);
        wrapper.extendModel();
        wrapper.update();
    });

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.ProductCompare.Messages.GetModel());
});